function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCluster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "#1CA182",
    stroke: "black",
    style: {
      fill: "#1CA182",
      fill: "color(display-p3 0.1098 0.6314 0.5098)",
      fillOpacity: 1,
      stroke: "black",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/cluster.074c9e13fecefe5f70516a275d234baf.svg";
export { ForwardRef as ReactComponent };